import { render, staticRenderFns } from "./gradeList.vue?vue&type=template&id=33485904&scoped=true"
import script from "./gradeList.vue?vue&type=script&lang=js"
export * from "./gradeList.vue?vue&type=script&lang=js"
import style0 from "./gradeList.vue?vue&type=style&index=0&id=33485904&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33485904",
  null
  
)

export default component.exports